<template>
    <div class="animated fadeIn pt-1">
        <ValidationObserver ref="observer">
            <b-row>
                <b-col md="12">
                    <ul class="heading-ul">
                        <li>
                            <button size="sm" @click="backButton">
                                <i
                                    class="fa fa-arrow-left font-size-18 text-dark-gray"
                                    aria-hidden="false"
                                ></i>
                            </button>
                        </li>
                        <li><h4>Add Feature</h4></li>
                    </ul>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <b-card border-variant="info">
                        <b-row>
                            <b-col cols="12" sm="12" md="12">
                                <div class="form-group">
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="Feature Name"
                                    >
                                        <b-form-input
                                            maxlength="100"
                                            placeholder="Enter Feature Name"
                                            v-model="featureName"
                                        ></b-form-input>
                                        <span class="validate-error">{{
                                            errors[0]
                                        }}</span>
                                    </ValidationProvider>
                                </div>
                            </b-col>
                            <b-col cols="12" sm="12" md="12">
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Description"
                                >
                                    <textarea
                                        class="form-control"
                                        type="text"
                                        rows="3"
                                        placeholder="Enter Description"
                                        v-model="featureDescription"
                                    />
                                    <span class="validate-error">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" sm="12" md="6"><h4>Add Permission</h4> </b-col>
                <b-col cols="12" sm="12" md="4">
                    <div class="form-group">
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Permission"
                        >
                            <multiselect
                                class="perm_input"
                                :options="allPermissions"
                                placeholder="Select a Permission"
                                label="name"
                                track-by="_id"
                                :multiple="false"
                                v-model="permission"
                            ></multiselect>
                            <span class="validate-error">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                </b-col>
                <b-col cols="12" sm="12" md="2">
                    <div class="btnReload_Div">
                        <b-button
                            block
                            variant="primary"
                            :disabled="permission == ''"
                            @click="onClickAddPermission"
                            >Add
                        </b-button>
                        <b-button
                            size="lg"
                            variant="success"
                            @click="reloadData"
                            :disabled="isLoading"
                        >
                            <span
                                v-if="isLoading"
                                class="fa fa-refresh fa-spin font-size-15"
                            />
                            <span
                                v-else
                                class="fa fa-refresh font-size-15"
                            />
                        </b-button>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <b-card border-variant="info">
                        <div>
                            <b-table
                                class="rounded-table"
                                responsive
                                :items="tableData"
                                :fields="tableFields"
                                :per-page="perPage"
                                :current-page="currentPage"
                                thead-class="header"
                                show-empty
                                :no-border-collapse="true"
                                :filter="filter"
                                @filtered="onFilter"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                            >
                                <template slot="cell(empty)">
                                    <div v-if="isLoading" class="text-center">
                                        <span><b>Loading...</b></span>
                                    </div>
                                    <div v-else class="text-center">
                                        No data available.
                                    </div>
                                </template>
                                <template slot="cell(Action)" slot-scope="data">
                                    <div class="d-flex">
                                        <div>
                                            <b-button
                                                size="sm"
                                                class="border-0 circularIcon"
                                                variant="danger"
                                                @click="
                                                    deleteTableItem(data.index)
                                                "
                                            >
                                                <i class="fa fa-trash"></i>
                                            </b-button>
                                        </div>
                                    </div>
                                </template>
                            </b-table>
                        </div>
                        <div class="pagination-wrapper">
    <b-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total-rows="filterCount"
        aria-controls="my-table"
        prev-text="Prev"
        next-text="Next"
        hide-goto-end-buttons
    ></b-pagination>
</div>

                    </b-card>
                </b-col>
            </b-row>
            <b-row class="justify-content-center">
                <b-col md="12">
                    <div class="cancelSaveBtn">
                        <b-button
                            variant="danger"
                            class="btn btn-danger btn-width-100"
                            @click="onClickClear"
                            >Cancel
                        </b-button>
                        <b-button
                            class="btn-width-100"
                            variant="primary"
                            @click="onClickSave"
                            >Save
                        </b-button>
                    </div>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template>

<script>
import { mapState } from "vuex";
import {
    ValidationProvider,
    ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";

export default {
    name: "features",
    props: {},
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return {
            isLoading: false,
            filterCount: 0,
            filter: "",
            sortBy: "createdAt",
            sortDesc: true,
            currentPage: 1,
            perPage: 10,
            featureName: "",
            featureDescription: "",
            permission: "",
            tableFields: [
                {
                    label: "Resource",
                    key: "resource",
                },
                {
                    label: "Permission",
                    key: "name",
                },
                {
                    label: "Method",
                    key: "action",
                },
                {
                    label: "Action",
                    key: "Action",
                },
            ],
            tableData: [],
        };
    },
    computed: {
        ...mapState({
            allPermissions: (state) => state.permission.permissionList,
        }),
    },
    methods: {
        async reloadData() {
            this.isLoading = true;
            await this.$store.dispatch("permission/fetchAllPermission");
            this.isLoading = false;
        },
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        onClickAddPermission() {
            if (this.tableData.includes(this.permission)) {
                this.$toasted.error("Permission Already Added!");
            } else {
                if (this.permission !== null) {
                    this.tableData.push(this.permission);
                    this.$toasted.success("Permission Added Successfully");
                } else {
                    this.$toasted.error("Please select a Permission");
                }
            }
        },
        backButton() {
            this.$router.push({ path: "/features" });
        },
        onClickClear() {
            this.tableData = [];
            this.featureName = "";
            this.featureDescription = "";
            this.$router.push({ path: "/features" });
        },
        async onClickSave() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) return;

            this.isLoading = true;
            let payload = {
                name: this.featureName,
                description: this.featureDescription,
                permission: this.tableData,
            };
            if (payload.name.length != 0 && payload.permission.length != 0) {
                await this.$store.dispatch("feature/addFeature", payload);
                this.isLoading = false;
                this.$router.push({ path: "/features" });
            } else {
                this.$swal({
                    title: "Error",
                    text: "Please fill all required fields.",
                    type: "error",
                });
            }
            this.isLoading = false;
        },
        deleteTableItem(index) {
            this.$swal({
                title: "Are you sure?",
                text: "",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Delete",
                confirmButtonColor: "#d33",
                cancelButtonColor: "#d33",
                reverseButtons: true,
            })
                .then((result) => {
                    if (result.value) {
                        this.tableData.splice(index, 1);
                        this.$toasted.success(
                            "Permission Deleted Successfully",
                        );
                    }
                })
                .catch((error) => {
                    this.$toasted.error(error.message);
                });
        },
    },
    async mounted() {
        this.isLoading = true;
        await this.$store.dispatch("permission/fetchAllPermission");
        this.isLoading = false;
    },
};
</script>

<style>
.table td {
    text-align: center;
}
tbody tr:nth-child(2n + 1) {
    border-bottom: 1px solid #e8e5e5;
}
.perm_input .multiselect__single {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.font-size-18 {
    font-size: 18px;
}

.text-dark-gray {
    color: rgb(38, 38, 38);
}

.font-size-15 {
    font-size: 15px;
}

.rounded-table {
    border-radius: 12px;
}

.btn-width-100 {
    width: 100px;
}

@media (max-width: 768px) {
    .cancelSaveBtn .btn-danger {
        margin-bottom: 10px;
    }
}
</style>
